const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/7662fa13-a20c-42f4-8e5d-f8666613b6c9/images/d2947a257588772c009a84193e8a22349b1f1998b476a3dd820a635d2bc44fc9.png";

const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-black grain"
    >
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Logística global Sacaru"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
      </div>

      {/* blobs */}
      <div className="blob bg-[#C7343D] w-[500px] h-[500px] top-[-150px] right-[-100px]" />
      <div className="blob bg-[#F3901A] w-[400px] h-[400px] bottom-[-100px] left-[-100px] opacity-30" />

      <div className="relative z-10 max-w-[1500px] mx-auto px-6 lg:px-12 pt-40 pb-24 min-h-screen flex flex-col justify-center">
        {/* Main heading */}
        <div>
          <div
            className="reveal-up"
            style={{ animationDelay: "0.15s" }}
          >
            <span className="text-[#F3901A] text-sm font-semibold tracking-[0.3em] uppercase">
              ¡Somos Distribuidora Sacaru!
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-white text-balance text-5xl sm:text-6xl lg:text-8xl xl:text-[8.5rem] font-light leading-[0.95] tracking-[-0.04em] mt-6 reveal-up"
            style={{ animationDelay: "0.3s" }}
          >
            Tu organización
            <br />
            <span className="italic font-extralight text-white/90">
              de confianza
            </span>{" "}
            para realizar
            <br />
            tus compras y operaciones
            <br />
            generales de <span className="text-[#C7343D]">comercio.</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default Hero;
